import * as yup from 'yup'
import {
  AdditionalDetailsOptionalInputSchema,
  AddressInputSchema,
  AliasOptionalInputSchema,
  IbanBeneficiarySchema,
  PostalCodeInputSchema,
  StreetAddressInputSchema,
} from './common'
import { SwiftInputSchema } from './common/Swift'
import {
  COMPANY_NAME_REGEX,
  LATINICA_ONLY_MESSAGE,
  LATINICA_ONLY_REGEXP,
  MIN_LENGTH,
  NUMBER_AND_LATINICA_AND_SPECIAL_SYMBOLS,
  THIS_FIELD_IS_REQUIRED_MESSAGE,
} from '../constants/validations'
import i18n from '../i18n'
import { SpecificReqFieldsInputSchema } from './SpecReqFieldsSchema'

export const RecipientSchema = yup
  .object()
  .shape({
    bankName: yup
      .mixed()
      .test({
        name: 'nameOptional',
        message: i18n.t('theFieldMustHaveLatin', 'Must have at least {{min}} characters', {
          min: MIN_LENGTH,
        }),
        test: (value) => (!!value && value?.length >= 2) || value === '',
      })
      .test({
        name: 'numberAndLatinicaField',
        message: NUMBER_AND_LATINICA_AND_SPECIAL_SYMBOLS,
        test: (value) => COMPANY_NAME_REGEX.test(value),
      })
      .required(THIS_FIELD_IS_REQUIRED_MESSAGE),
    recipientType: yup
      .string()
      .required(THIS_FIELD_IS_REQUIRED_MESSAGE)
      .matches(LATINICA_ONLY_REGEXP, LATINICA_ONLY_MESSAGE),
    name: yup
      .mixed()
      .test({
        name: 'nameOptional',
        message: i18n.t('theFieldMustHaveLatin', 'Must have at least {{min}} characters', {
          min: MIN_LENGTH,
        }),
        test: (value) => (!!value && value?.length >= 2) || value === '',
      })
      .test({
        name: 'numberAndLatinicaField',
        message: NUMBER_AND_LATINICA_AND_SPECIAL_SYMBOLS,
        test: (value) => COMPANY_NAME_REGEX.test(value),
      })
      .required(THIS_FIELD_IS_REQUIRED_MESSAGE),
  })
  .concat(StreetAddressInputSchema)
  .concat(AddressInputSchema)
  .concat(IbanBeneficiarySchema)
  .concat(SwiftInputSchema)
  .concat(AdditionalDetailsOptionalInputSchema)
  .concat(PostalCodeInputSchema)
  .concat(AliasOptionalInputSchema)
  .concat(SpecificReqFieldsInputSchema)
